import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import AutocompleteSuggestion from 'react-google-places-autocomplete';
import {
  GooglePlace,
  generateGoogleMapsPreview,
} from 'lib/utils/googleMapsEmbed';
import { MdClear } from 'react-icons/md';
import { Gap } from 'lib/components/styles/layout';
import {
  ClearMapWrapper,
  FormikGoogleMapsWrapper,
  GoogleAutocompleteWrapper,
  IFrameWrapper,
} from './styles';
import { useTranslation } from 'react-i18next';

interface IFormikGoogleMapsProps {
  name: string;
  width?: number;
}

const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: '40px',
    fontSize: '1rem',
    lineHeight: '1.5',
    backgroundColor: '#fff',
    border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
    borderRadius: '0.25rem',
    boxShadow: state.isFocused
      ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'
      : 'none',
    transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    '&:hover': {
      borderColor: state.isFocused ? '#80bdff' : '#ced4da',
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '0.375rem 0.75rem',
  }),
  input: (provided: any) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#495057',
    opacity: 0.7,
  }),
};

export const FormikGoogleMaps = (props: IFormikGoogleMapsProps) => {
  const { t } = useTranslation();
  const [field, , helpers] = useField(props.name);
  const [chosenGooglePlace, setChosenGooglePlace] =
    useState<GooglePlace | null>();
  const [googleMapPreview, setGoogleMapPreview] = useState('');

  useEffect(() => {
    setGoogleMapPreview(generateGoogleMapsPreview(field.value));
  }, [field.value]);

  return (
    <FormikGoogleMapsWrapper>
      <Gap gap='8px' justifyContent='space-between' flexWrap='nowrap'>
        <GoogleAutocompleteWrapper>
          <AutocompleteSuggestion
            apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            selectProps={{
              styles: customStyles,
              value: chosenGooglePlace,
              isClearable: false,
              placeholder: t('googleMapPlaceholderText', {
                action: field.value ? t('change') : t('find'),
              }),
              components: {
                IndicatorSeparator: null,
                DropdownIndicator: null,
              },
              onChange: (value: any) => {
                helpers.setValue(value?.value?.place_id || '');
                setChosenGooglePlace(value as GooglePlace);
              },
            }}
          />
        </GoogleAutocompleteWrapper>
        {!!field.value && (
          <ClearMapWrapper>
            <MdClear
              onClick={() => {
                helpers.setValue('');
                setChosenGooglePlace(null);
                setGoogleMapPreview('');
              }}
            />
          </ClearMapWrapper>
        )}
      </Gap>
      {!!googleMapPreview && (
        <IFrameWrapper
          dangerouslySetInnerHTML={{
            __html: googleMapPreview,
          }}
        />
      )}
    </FormikGoogleMapsWrapper>
  );
};
